import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { DateButtonOverlay, DateButton } from "./DateButton.mjs";
import { DateButtonDisabled } from "./DateButtonDisabled.mjs";
import { DateButtonInactive } from "./DateButtonInactive.mjs";
import { dateButtonWrapper, inRangeOverlay, startDateOverlayCompact, startDateOverlay, endDateOverlayCompact, endDateOverlay } from "./DateButton.css.mjs";
const DateButtonWrapper = ({
  deactivateEndDate,
  deactivateStartDate,
  children,
  isActive,
  isDisabled,
  isEnd,
  isInRange,
  isStart,
  isCompact = false,
  value,
  onClick
}) => {
  if (isDisabled) {
    return /* @__PURE__ */ jsx(DateButtonDisabled, { isCompact, children });
  }
  const isInactive = isStart && !isEnd && deactivateStartDate || isEnd && !isStart && deactivateEndDate;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: dateButtonWrapper,
      "data-in-range": isInRange ? "true" : "false",
      "data-is-end": isEnd && !isStart ? "true" : "false",
      "data-is-start": isStart && !isEnd ? "true" : "false",
      display: "block",
      position: "relative",
      marginY: "xxsmall",
      style: { paddingLeft: isCompact ? "4px" : "6px" },
      children: [
        /* @__PURE__ */ jsx(
          DateButtonOverlay,
          {
            background: "neutralLight",
            className: inRangeOverlay
          }
        ),
        /* @__PURE__ */ jsx(
          DateButtonOverlay,
          {
            background: "neutralLight",
            className: isCompact ? startDateOverlayCompact : startDateOverlay
          }
        ),
        /* @__PURE__ */ jsx(
          DateButtonOverlay,
          {
            background: "neutralLight",
            className: isCompact ? endDateOverlayCompact : endDateOverlay
          }
        ),
        isInactive ? /* @__PURE__ */ jsx(DateButtonInactive, { isCompact, children }) : /* @__PURE__ */ jsx(
          DateButton,
          {
            isActive,
            isCompact,
            onClick,
            value,
            children
          }
        )
      ]
    }
  );
};
export {
  DateButtonWrapper
};
